// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 751) return "content/plugin-quality-monitoring/6f840aff7ca074cade6c04f2f736492b.js";
	// return url for filenames based on template
	return undefined;
};